<template>
  <div class="sidebar-group left-sidebar chat_sidebar"
       :class="{'hide-left-sidebar': showChat, small}"
  >
    <div class="wrapper">
      <div class="left-sidebar-wrap sidebar active">
        <!-- Left Sidebar Header -->
        <div class="left-chat-title all-chats d-flex justify-content-between align-items-center">
          <div class="select-group-chat w-full">
            <h4 class="sidebar-title">
              <slot name="title"></slot>
            </h4>
          </div>
        </div>
        <!-- /Left Sidebar Header -->

        <div class="scroll-area overflow-y-auto">
          <div class="sidebar-body chat-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },

  props: {
    hideSearch: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showSearch: false,
      showChat: false,
      settings: {
        suppressScrollX: true,
      },
    };
  },

  computed: {
    currentPath() {
      return this.$route.name;
    },
  },

  mounted() {
    this.$eventHub.$on('toggleChat', this.onToggleChat);
  },

  methods: {
    scrollHandle(evt) {
      //
    },

    onToggleSearch() {
      this.showSearch = !this.showSearch;
      this.$emit('show-search', this.showSearch);
    },

    onToggleChat(state = null) {
      this.showChat = state;

      if (this.showChat) {
        this.$eventHub.$emit('toggleMenu', false);
      }
    }
  },
};
</script>
